// extracted by mini-css-extract-plugin
export var styles = "bottom-module--styles--3gxlx";
export var zzz = "bottom-module--zzz--1ugYo";